import { render, staticRenderFns } from "./EditChildStoryContributor.vue?vue&type=template&id=1c5ab034&scoped=true&"
import script from "./EditChildStoryContributor.vue?vue&type=script&lang=js&"
export * from "./EditChildStoryContributor.vue?vue&type=script&lang=js&"
import style0 from "./EditChildStoryContributor.vue?vue&type=style&index=0&id=1c5ab034&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ab034",
  null
  
)

export default component.exports